(function(){
  function onReady(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  onReady(function(){
    var header = document.querySelector('.h2-header');
    if(header && document.body.classList.contains('template-index')){
      var setHeader = function(){ header.classList.toggle('is-solid', window.scrollY > 80); };
      setHeader(); window.addEventListener('scroll', setHeader, {passive:true});
    }
    document.querySelectorAll('[data-mobile-menu]').forEach(function(btn){
      btn.addEventListener('click', function(){ document.body.classList.toggle('h2-menu-open'); });
    });
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn){
      btn.addEventListener('click', function(){ var input = btn.parentElement.querySelector('input'); var n = Math.max(1, parseInt(input.value || '1', 10) - 1); input.value = n; });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function(btn){
      btn.addEventListener('click', function(){ var input = btn.parentElement.querySelector('input'); var n = Math.max(1, parseInt(input.value || '1', 10) + 1); input.value = n; });
    });
  });
})();